import { FC } from "react";
import Card12 from "./Card12";
import Card14 from "./card14";

export interface SectionMagazine5Props {
  posts: any[];
}

const SectionMagazine5: FC<SectionMagazine5Props> = ({ posts }) => {
  if (!posts || posts.length === 0) {
    return (
      <div className="nc-SectionMagazine5">
        <div className="text-center py-12">
          <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-primary-100 to-secondary-100 rounded-full flex items-center justify-center">
            <svg className="w-10 h-10 text-primary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
              />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-neutral-700 dark:text-neutral-300 mb-2">
            Aucun article disponible
          </h3>
          <p className="text-neutral-500 dark:text-neutral-400">Les articles seront bientôt disponibles</p>
        </div>
      </div>
    );
  }

  return (
    <div className="nc-SectionMagazine5">
      {/* Featured Section Header */}
      <div className="text-center mb-12">
        <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-accent-50 to-primary-50 rounded-full text-sm font-medium text-accent-600 mb-4">
          <span className="w-2 h-2 bg-accent-500 rounded-full mr-2 animate-pulse"></span>
          Articles en vedette
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-neutral-900 dark:text-neutral-100">
          Les plus populaires
        </h2>
      </div>

      <div className="grid lg:grid-cols-2 gap-8 md:gap-12">
        {/* Main Featured Article */}
        <div className="group relative">
          {posts[0] && (
            <div className="relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:scale-[1.02]">
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent pointer-events-none z-10"></div>
              <Card12 post={posts[0]} />
              {/* Featured Badge */}
              <div className="absolute top-6 left-6 z-20 pointer-events-none">
                <span className="inline-flex items-center px-3 py-1 bg-gradient-to-r from-primary-500 to-secondary-500 text-white text-xs font-medium rounded-full shadow-lg">
                  <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                  À la une
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Secondary Articles Grid */}
        <div className="space-y-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Derniers articles</h3>
            <div className="w-12 h-px bg-gradient-to-r from-primary-500 to-secondary-500"></div>
          </div>

          <div className="space-y-6">
            {Array.isArray(posts) &&
              posts
                .filter((_, i) => i < 4 && i > 0)
                .map((item, index) => (
                  <div
                    key={index}
                    className="group relative overflow-hidden rounded-2xl hover:shadow-lg transition-all duration-300 transform hover:scale-[1.01]"
                    style={{
                      animationDelay: `${index * 100}ms`,
                    }}
                  >
                    <div className="absolute inset-0 bg-gradient-to-r from-primary-500/5 to-secondary-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <Card14 post={item} />

                    {/* Article Number Badge */}
                    <div className="absolute top-4 right-4 w-8 h-8 bg-white dark:bg-neutral-800 rounded-full shadow-lg flex items-center justify-center text-sm font-bold text-primary-600 opacity-0 group-hover:opacity-100 transition-all duration-300 transform scale-90 group-hover:scale-100">
                      {index + 2}
                    </div>
                  </div>
                ))}
          </div>

          {/* Read More Button */}
          {posts.length > 4 && (
            <div className="pt-6">
              <button className="w-full py-4 bg-gradient-to-r from-neutral-50 to-neutral-100 dark:from-neutral-800 dark:to-neutral-700 rounded-2xl text-neutral-700 dark:text-neutral-300 font-medium hover:from-primary-50 hover:to-secondary-50 dark:hover:from-primary-900/20 dark:hover:to-secondary-900/20 hover:text-primary-600 dark:hover:text-primary-400 transition-all duration-300 transform hover:scale-[1.02] border border-neutral-200 dark:border-neutral-600 hover:border-primary-200 dark:hover:border-primary-700">
                <div className="flex items-center justify-center space-x-2">
                  <span>Voir plus d'articles</span>
                  <svg
                    className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    />
                  </svg>
                </div>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute -top-6 -left-6 w-24 h-24 bg-gradient-to-br from-primary-200/30 to-secondary-200/30 rounded-full blur-xl"></div>
      <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-br from-accent-200/20 to-primary-200/20 rounded-full blur-xl"></div>
    </div>
  );
};

export default SectionMagazine5;
